
const shameQuestion = {
  name: 'shame',
  title: 'Do you feel uncomfortable in your body around others?',
  type: 'radiogroup',
  description: "Understanding your comfort level helps us guide you better – no judgement, just insight.",
  choices: [
    "Often",
    "Occasionally",
    "Rarely / Never",
  ],
  isRequired: true,
};

export {
  shameQuestion,
}